import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Wind, Plus, Trash2, Save } from "lucide-react";

export default function EstrusioneMacchineTab() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [form, setForm] = useState({ codice: "", descrizione: "" });

    const load = async () => {
        setLoading(true);
        try { const { data } = await api.get("/macchine-estrusione"); setItems(data); }
        catch (e) { toast.error(formatApiError(e)); }
        finally { setLoading(false); }
    };
    useEffect(() => { load(); }, []);

    const add = async () => {
        if (!form.codice) { toast.error("Codice obbligatorio"); return; }
        try {
            await api.post("/macchine-estrusione", { codice: form.codice.toUpperCase(),
                descrizione: form.descrizione || null, attiva: true });
            setForm({ codice: "", descrizione: "" }); toast.success("Macchina aggiunta"); load();
        } catch (e) { toast.error(formatApiError(e)); }
    };

    const saveOne = async (m) => {
        try { await api.put(`/macchine-estrusione/${m.id}`, {
            codice: m.codice, descrizione: m.descrizione || null, attiva: !!m.attiva });
            toast.success("Salvato"); load();
        } catch (e) { toast.error(formatApiError(e)); }
    };

    const delOne = async (m) => {
        if (!window.confirm(`Eliminare ${m.codice}?`)) return;
        try { await api.delete(`/macchine-estrusione/${m.id}`); toast.success("Eliminata"); load(); }
        catch (e) { toast.error(formatApiError(e)); }
    };

    return (
        <div className="space-y-5">
            <Card className="card p-5">
                <div className="flex items-center gap-3 mb-4">
                    <div className="p-2 rounded-lg bg-cyan-500/10 border border-cyan-500/30 text-cyan-300"><Wind size={18} /></div>
                    <div>
                        <h2 className="font-display font-extrabold text-lg">Macchinari estrusione</h2>
                        <p className="text-xs text-slate-500">Elenco estrusori. Attive = visibili in Ordini/Produzione.</p>
                    </div>
                </div>
                <div className="space-y-2">
                    {loading && <div className="text-slate-500 text-xs">Caricamento…</div>}
                    {items.map(m => (
                        <div key={m.id} className="flex items-center gap-2 p-2 rounded bg-slate-900/40 border border-slate-800" data-testid={`row-macc-estr-${m.codice}`}>
                            <Input value={m.codice} onChange={e=>setItems(items.map(x => x.id===m.id ? {...x, codice: e.target.value.toUpperCase()} : x))}
                                   className="bg-slate-950/50 border-slate-800 font-mono w-24" />
                            <Input value={m.descrizione || ""} placeholder="Descrizione"
                                   onChange={e=>setItems(items.map(x => x.id===m.id ? {...x, descrizione: e.target.value} : x))}
                                   className="bg-slate-950/50 border-slate-800 flex-1" />
                            <div className="flex items-center gap-2">
                                <Label className="text-xs text-slate-400">Attiva</Label>
                                <Switch checked={!!m.attiva} onCheckedChange={v=>setItems(items.map(x => x.id===m.id ? {...x, attiva: v} : x))} />
                            </div>
                            <Button size="sm" onClick={()=>saveOne(m)} data-testid={`btn-save-macc-${m.codice}`} className="bg-amber-500 hover:bg-amber-400 text-slate-950 gap-1"><Save size={12}/> Salva</Button>
                            <button onClick={()=>delOne(m)} className="p-2 rounded hover:bg-red-500/20 text-red-400" data-testid={`btn-del-macc-${m.codice}`}><Trash2 size={14}/></button>
                        </div>
                    ))}
                </div>
                <div className="mt-4 pt-4 border-t border-slate-800 flex gap-2">
                    <Input placeholder="Codice (es. ES6)" value={form.codice}
                           onChange={e=>setForm({...form, codice: e.target.value.toUpperCase()})}
                           data-testid="input-new-macc-codice"
                           className="bg-slate-950/50 border-slate-800 font-mono w-32" />
                    <Input placeholder="Descrizione" value={form.descrizione}
                           onChange={e=>setForm({...form, descrizione: e.target.value})}
                           data-testid="input-new-macc-desc"
                           className="bg-slate-950/50 border-slate-800 flex-1" />
                    <Button onClick={add} data-testid="btn-add-macc" className="bg-amber-500 hover:bg-amber-400 text-slate-950 gap-1"><Plus size={14}/> Aggiungi</Button>
                </div>
            </Card>
        </div>
    );
}
